import { SendPushNotificationRequest } from './push-notification.types';

import { API_HOST, HttpPostOptions, getHttpPostOptions } from '../../../utils/api.util';

const getEndpoint = () => `${API_HOST}/notification/push`;

export const getSendPushNotificationRequest = (
  data: SendPushNotificationRequest
): [string, HttpPostOptions<SendPushNotificationRequest>] => [`${getEndpoint()}/send`, getHttpPostOptions(data)];
